export const SessionTimeoutModalStyles = {
  backdrop: {
    color: '#fff !important',
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    margin: '20px !important',
    zIndex: 1500,
  },
  inactivityModalRoot: {
    display: 'flex !important',
    alignItems: 'center !important',
    maxWidth: '322px !important',
    borderRadius: '10px !important',
    background: '#ffffff',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    '@media screen and (max-width:400px)': {
      maxHeight: 'unset !important',
    },
  },
  closeOverlay: {
    top: '29px !important',
    color: '#ffffff !important',
    width: '44px',
    cursor: 'pointer !important',
    height: '28px',
    position: 'relative !important',
  },
  rootSessionTimeoutModal: {
    display: 'flex !important',
    alignItems: 'center !important',
    maxWidth: '332px !important',
    borderRadius: '10px !important',
    background: '#ffffff',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    '@media screen and (max-width:400px)': {
      maxHeight: 'unset !important',
    },
  },
  card_content: {
    textAlign: 'center !important',
    padding: '0px !important',
    margin: '0px !important',
  },
  continueAppButton: {
    background: '#661c69 0% 0% no-repeat padding-box !important',
    color: '#ffffff !important',
    letterSpacing: '0.1px !important',
    font: 'normal 700 14px/16px Arial, sans-serif !important',
    width: '103px !important',
    height: '32px !important',
    margin: '17px 0 30px 0 !important',
    borderRadius: '56px !important',
    opacity: '1 !important',
    textTransform: 'none !important',
    minWidth: 'unset !important',
    '&:hover': {
      backgroundColor: '#661c69 !important',
    },
    '&:focus': {
      outline: '2px solid #661c69',
      outlineOffset: '2px',
    },
  },
  restart_app_button: {
    background: '#661c69 0% 0% no-repeat padding-box !important',
    color: '#ffffff !important',
    letterSpacing: '0.1px !important',
    font: 'normal normal normal 14px/17px Arial, sans-serif !important',
    width: '200px !important',
    height: '44px !important',
    margin: '17px 0px 30px 0px !important',
    borderRadius: '56px !important',
    opacity: '1 !important',
    textTransform: 'none !important',
    minWidth: 'unset !important',
    '&:hover': {
      backgroundColor: '#661c69 !important',
    },
    '&:focus': {
      outline: '2px solid #9c8e9c',
      outlineOffset: '2px',
    },
  },
  textOneInactiveStyle: {
    font: 'normal 400 16px/18px Arial, sans-serif !important',
    color: '#000000 !important',
    letterSpacing: '0.1px !important',
    marginTop: '42px !important',
    marginLeft: '26px !important',
    marginRight: '26px !important',
  },
  textOneSessionStyle: {
    font: 'normal 700 16px/19px Arial, sans-serif !important',
    color: '#000000 !important',
    letterSpacing: '0.12px !important',
    marginTop: '42px !important',
    marginLeft: '26px !important',
    marginRight: '26px !important',
  },
  textTwoSessionStyle: {
    font: 'normal 400 16px/18px Arial, sans-serif !important',
    color: '#000000 !important',
    letterSpacing: '0.1px !important',
    marginTop: '20px !important',
    marginLeft: '26px !important',
    marginRight: '26px !important',
  },
  close_icon: {
    width: '34px !important',
    height: '34px !important',
    cursor: 'pointer !important',
    margin: '5px 5px 0 0 !important',
  },
  modal_close: {
    color: '#661c69 !important',
    textAlign: 'right !important',
    height: '35px !important',
  },
  sessionmodal: {
    outline: 'none',
  },
  sessioncontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  closeicon: {
    width: '25px',
    height: '25px',
  },

  productmodal: {
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px',
    gap: '24px',
    maxWidth: '420px',
    borderRadius: '24px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
    '@media(max-width:600px)': {
      maxWidth: '272px',
    },
  },

  productmodalcontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },

  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '12px',
  },

  errorTitle: {
    font: 'normal 700 20px/18px Arial !important',
    letterSpacing: '0px',
    textAlign: 'center',
  },

  errorDescription: {
    font: 'normal 400 16px/18px Arial !important',
    letterSpacing: '0px',
    textAlign: 'center',
  },

  restartButton: {
    height: '40px',
    borderRadius: '56px !important',
    padding: '12px 36px',
    letterSpacing: '0px !important',
    font: 'normal 700 14px/16px Arial !important',
    fontWeight: '700',
    textAlign: 'center',
    opacity: '1 !important',
    textTransform: 'none !important',
  },

  inactivityMSG: {
    font: 'normal 700 16px/18px Arial !important',
    letterSpacing: '0px',
    textAlign: 'center',
  },

  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
  },
};
